import React from "react";
import { littleGreen } from "../../CommonComponent/DefineColors";

const CustomButton = ({ buttons }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        padding: "8px",
      }}
    >
      {buttons.map((btn, index) => (
        <button
          key={index}
          onClick={btn.onClick}
          style={{
            backgroundColor: "rgb(240, 240, 240)",
            border: "1px solid rgb(204, 204, 204)",
            borderRadius: "10px",
            padding: "4px",
            cursor: "pointer",
            fontSize: "12px",
            color: "black",
            width: "100%",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = littleGreen)}
          onMouseOut={(e) =>
            (e.target.style.backgroundColor = "rgb(240, 240, 240)")
          }
        >
          {btn.name}
        </button>
      ))}
    </div>
  );
};

export default CustomButton;
